<template>
  <div class="cielo-farol-wrapper">
    <h1 class="title">Carregando...</h1>
  </div>
</template>

<script>
export default {
  name: "CieloFarol",
  created() {
    var event = new Event("loaded");
    window.parent.dispatchEvent(event);
  },
};
</script>

<style>
.cielo-farol-wrapper {
  height: 90vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title {
  font-size: 22px;
  font-weight: 300;
  position: relative;
  top: 60px;
  margin: 0;
}
</style>
